import { Builder } from '@builder.io/react';
import EmbedCustom from './embedCustom';
import embeds from './embedProviders';

Builder.registerComponent(EmbedCustom, {
  name: 'Embed Custom',
  static: true,
  inputs: [
    {
      name: 'service',
      type: 'string',
      enum: Object.keys(embeds),
      required: true,
      defaultValue: Object.keys(embeds)[0],
    },
    {
      name: 'embedCode',
      type: 'longText',
      required: false,
      defaultValue: "<script>console.log('Remove this whole placeholder and put the script here')</script>",
    },
  ],
});
